import { Trans } from '@lingui/react/macro'
import { ExternalLink } from 'lucide-react'

// The ledger payout sub carries no per-payout claim URL — only requiresUserAction +
// actionReason. Point at PayPal's generic account page (a stable, real affordance, not a
// fabricated deep link); a recipient whose email isn't yet a PayPal account claims via the
// email PayPal sends.
const PAYPAL_CLAIM_URL = 'https://www.paypal.com/myaccount/'

export const PayoutClaimCta = () => (
  <a
    className="text-body-3 text-orange inline-flex w-fit items-center gap-1 font-medium hover:underline"
    href={PAYPAL_CLAIM_URL}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Trans>Claim on PayPal</Trans>
    <ExternalLink size={14} />
  </a>
)
